import { render } from "./index.vue?vue&type=template&id=80dbd980&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"

import "../../../styles/van-sticky-nav.css?vue&type=style&index=0&id=80dbd980&scoped=true&lang=css"
import "./index.vue?vue&type=style&index=1&id=80dbd980&scoped=true&lang=css"

import exportComponent from "/Users/leaf/Desktop/gmhwork/h5/zksq_H5/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-80dbd980"]])

export default __exports__